var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.pillTag,_vm._b({tag:"component",staticClass:"tag-pill",class:`tag-pill-${_vm.category}`},'component',_vm.pillAttrs,false),[_c('span',{staticClass:"tag-pill-dot",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }